import graphql__3dd3f1f8a0d763de9bbd from "./__generated__/AuthenticationSamlForm_samlAuth.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ButtonLink from "../Buttons/ButtonLink";

const AuthenticationSamlForm = props => {
  const samlAuth = useFragment(AuthenticationSamlForm_samlAuth, props.samlAuth);
  const { signInUrl, label } = samlAuth;

  const className = classNames(["form-wrapper", props.className]);

  return (
    <div className={className} data-saml-auth-form>
      <ButtonLink
        className="btn btn-primary-inverse btn-block-md box-shadow-lg"
        href={signInUrl}
        target="_self"
        type="button"
        label={label}
        iconClassName="icon-connexion"
        iconPosition="after"
        data-choose-saml-auth-button
      />
    </div>
  );
};

const AuthenticationSamlForm_samlAuth = graphql__3dd3f1f8a0d763de9bbd;

export default AuthenticationSamlForm;
